import { render } from "./SupplyHome.vue?vue&type=template&id=04b3597e&scoped=true"
import script from "./SupplyHome.vue?vue&type=script&lang=js"
export * from "./SupplyHome.vue?vue&type=script&lang=js"

import "./SupplyHome.vue?vue&type=style&index=0&id=04b3597e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b3597e"]])

export default __exports__